module.exports = __webpack_public_path__ + "static/img/nick-baker-VuPIUePS_vU-unsplash_thumb.44902c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/nick-baker-VuPIUePS_vU-unsplash_thumb.png
// module id = Xni0
// module chunks = 4